<script>
export default {
    name: "ConsultantProfileAppointments",

    data() {

        return {
            consultant: {},
            appointments: [],
            clinics: [],
            updateSchedule: false,
            filter: {
                from: window.moment().format(`YYYY-MM-DD`),
                to: window.moment().format(`YYYY-MM-DD`),
                consultantID: 0,
            },
        };
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchConsultantID(), ]).then(() => {
            this.fetchConsultant();
            this.fetchAppointments();
            this.fetchClinics();
            this.$root.loading = false;
        }).catch(() => {this.$root.loading = false;});
    },

    methods: {

        fetchConsultant() {
            if(!this.filter.consultantID) return Promise.reject();

            let url = `MasterData/GetSpecificConsultant`;
                url += `?ConsultantID=${this.filter.consultantID}`;

            return this.$http.get(url).then(({ data }) => {
                this.consultant = data.length ? data[0] : {};
            }).catch(() => {});
        },

        fetchConsultantID() {
            let url = `Admin/GetUserConsultantID`;
                url += `?UserName=${this.$root.username}`;

            return this.$http.get(url).then(({ data }) => {
                this.filter.consultantID = data;
            }).catch(() => {});
        },

        fetchClinics() {

            return this.$http.get(`Shared/GetDepartments`).then(({ data }) => {
                this.clinics = data;
            }).catch(() => {});
        },

        fetchAppointments() {
            if(!this.filter.consultantID) return Promise.reject();

            let url = `MedicalFile/GetConsultantAppointments`;
                url += `?Datefrom=${this.filter.from}`;
                url += `&Dateto=${this.filter.to}`;
                url += `&ConsultantId=${this.filter.consultantID}`;

            return this.$http.get(url).then(({ data }) => {
                this.appointments = data;
            }).catch(() => {});
        },

        formatTime() {
            return window.moment().format('H:mm')
        }
    },
    components: {

        "reschedule-appointment": () => import('./modals/Form.vue'),
    },
}
</script>
<template>
<tail-base-layout>
    <template v-slot:content>
        <tail-card>
            <template v-slot:card-header>
                <h5 class="font-medium text-sm">Consultant Appointments</h5>
            </template>
            <template v-slot:card-body>
                <div class="w-full flex flex-wrap p-2 bg-gray-200">
                    <div class="flex-1 p-tiny">
                        <h5 class="font-medium text-sm">Name:{{ consultant.names }}</h5>
                    </div>
                    <div class="flex-1 p-tiny">
                        <h5 class="font-medium text-sm">Contact: {{ consultant.phoneno || `-` }}</h5>
                    </div>
                    <div class="flex-1 p-tiny">
                        <h5 class="font-medium text-sm">Speciality: {{ consultant.speciality || `-` }}</h5>
                    </div>
                    <div class="flex-1 p-tiny">
                        <h5 class="font-medium text-sm">Prac. No: {{ consultant.practioninG_NO || `-` }}</h5>
                    </div>
                </div>
                <div class="w-full flex flex-wrap">
                    <div class="md:w-1/4 w-full p-1">
                        <label for="grid-from" class="label-control capitalize">From:</label>
                        <input type="date" v-model.trim="filter.from" id="grid-from" 
                            class="input-control input-sm text-xs">
                    </div>
                    <div class="md:w-1/4 w-full p-1">
                        <label for="grid-to" class="label-control capitalize">To:</label>
                        <input type="date" v-model.trim="filter.to" id="grid-to" 
                            class="input-control input-sm text-xs">
                    </div>
                    <div class="md:w-1/12 w-full p-1">
                        <button @click.prevent="() => {
                                $root.loading = true;
                                fetchAppointments().then(() => {
                                    $root.loading = false;
                                });
                            }"
                            class="btn-sm btn-primary text-xs rounded mt-4">
                            <i class="fa fa-filter"></i> Filter</button>
                    </div>
                </div>
                <div class="w-full overflow-auto">
                    <table class="table table-striped border">
                        <thead class="bg-blue-500 text-white text-sm">
                            <tr class="w-full flex">
                                <th class="p-tiny w-12">ID</th>
                                <th class="p-tiny flex-1">Patient</th>
                                <th class="p-tiny flex-1">Date</th>
                                <th class="p-tiny flex-1">Clinic</th>
                                <th class="p-tiny flex-1">Time</th>
                                <th class="p-tiny w-56">Comment</th>
                                <th class="p-tiny flex-1">Action</th>
                            </tr>
                        </thead>
                        <tbody class="bg-gray-100 flex flex-col items-center text-xs overflow-auto max-h-70">
                            <tr class="w-full flex" v-for="appointment in appointments" :key="appointment.id">
                                <td class="p-tiny w-12">{{ appointment.id }}</td>
                                <td class="p-tiny flex-1">
                                    <h5 class="text-xs">Name: {{ appointment.names}}</h5>
                                    <h5 class="text-xs">MRN: {{ appointment.patientID }}</h5>
                                    <h5 class="text-xs">IP: {{ appointment.ipfileno }}</h5>
                                    <h5 class="text-xs">OP: {{ appointment.opfileno }}</h5>
                                </td>
                                <td class="p-tiny flex-1">{{ appointment.date | dateFormat }}</td>
                                <td class="p-tiny flex-1">{{ appointment.clinic }}</td>
                                <td class="p-tiny flex-1">
                                    <h5 class="text-xs">Start: {{ appointment.startTime }}</h5>
                                    <h5 class="text-xs">End: {{ appointment.endTime }}</h5>
                                </td>
                                <td class="p-tiny w-56 break-words">
                                   <span v-html="appointment.comment"></span>
                                </td>
                                <td class="p-tiny flex-1">
                                    <button 
                                        @click.prevent="updateSchedule = true"
                                        class="btn-sm btn-info text-xs rounded">
                                            <i class="fa fa-calendar"></i> Reschedule</button>
                                    <reschedule-appointment 
                                        :appointment="{ 
                                            ...appointment, 
                                            appointmentDate: $root.formatDate(appointment.date),
                                            time: formatTime() }"
                                        :departments="clinics"
                                        :showModal="updateSchedule"
                                        @closeModal="updateSchedule = false"
                                        @refresh="fetchAppointments"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template v-slot:card-footer>
                <div class="w-full text-right">
                   <router-link :to="{ name: `home` }" class="btn-sm btn-danger text-xs rounded">
                    <i class="fa fa-caret-left"></i> Back</router-link> 
                </div>
            </template>
        </tail-card>  
    </template>
</tail-base-layout>
</template>